<script setup lang="ts">
import IconStar from '@/presentation/components/icons/IconStar.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
    <button
        class="th-btn th-btn-plain !pl-1"
    >
        <IconStar class="th-btn-icon mr-1 h-6 w-6 fill-primary"/>

        {{ t('aiTranslation.newTask') }}
    </button>
</template>
